import React from "react";
import { InstrumentItemManagement } from "@components/InstrumentItem";

export default function InstrumentItemIndex() {
  return <InstrumentItemManagement />;
}
